"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const react_router_redux_1 = require("react-router-redux");
const react_redux_toastr_1 = require("react-redux-toastr");
const LandingReducer_1 = require("./landing/LandingReducer");
const AuthenticationReducer_1 = require("./authentication/AuthenticationReducer");
const BusinessesReducer_1 = require("./app/business/BusinessesReducer");
const DialogReducer_1 = require("./shared/Dialog/DialogReducer");
const TemplateReducer_1 = require("./shared/Template/TemplateReducer");
const FeedbacksReducer_1 = require("./app/business/feedback/FeedbacksReducer");
const CustomersReducer_1 = require("./app/business/customers/CustomersReducer");
const rootReducer = redux_1.combineReducers({
    authentication: AuthenticationReducer_1.default,
    businesses: BusinessesReducer_1.default,
    dialogReducer: DialogReducer_1.default,
    template: TemplateReducer_1.default,
    landingPage: LandingReducer_1.landingReducer,
    routing: react_router_redux_1.routerReducer,
    toastr: react_redux_toastr_1.reducer,
    feedbacks: FeedbacksReducer_1.default,
    customers: CustomersReducer_1.default
});
exports.default = rootReducer;


//////////////////
// WEBPACK FOOTER
// ./client/src/reducer.ts
// module id = 582
// module chunks = 0 1 2